/** @format */

import { styles } from '@common/application/styles/global';
import styled from 'styled-components';

interface StyledTextAreaProps {
  disabled?: boolean;
}

export const StyledTextAreaCounter = styled.span<{ $lengthExceeded: boolean }>`
  display: block;
  text-align: right;
  font-size: 0.75rem;
  color: ${({ $lengthExceeded }) => ($lengthExceeded ? 'var(--red, #d33)' : styles.color)};
`;

export const StyledTextArea = styled.textarea<StyledTextAreaProps>`
  padding: 4px 8px;
  border: 1px solid ${styles.borderColor};
  border-radius: 4px;
  background-color: ${({ disabled }) => (disabled ? '#fcfcfc' : styles.backgroundColor)};
  width: 100%;
  box-sizing: border-box;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'text')};
  min-height: 68px;
  resize: vertical;
  font-family: inherit;
  font-size: inherit;
  color: ${({ disabled }) => (disabled ? 'var(--grey-200)' : styles.color)};

  :hover {
    border-color: ${({ disabled }) => (disabled ? styles.borderColor : styles.hover.borderColor)};
  }

  :focus {
    border-color: ${({ disabled }) => (disabled ? styles.borderColor : styles.active.borderColor)};
    outline: none;
  }
`;
